import React from 'react';
import { Card, CardContent, Typography, List, ListItem, ListItemText, Box } from '@mui/material';

const EventRegistration = ({ registeredEvents }) => {

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Eventos Inscritos
        </Typography>
        <List>
          {registeredEvents.map((event) => (
            <ListItem key={event.id}>
              <ListItemText primary={event.name} secondary={event.location} />
            </ListItem>
          ))}
        </List>
        {registeredEvents.length === 0 && <Box textAlign='center'>No estás inscrito a ningún evento</Box>}

      </CardContent>
    </Card>
  );
};

export default EventRegistration;